import { Controller } from "@hotwired/stimulus"

// Creates the Connect app from the promotion modal: shrinks the modal and swaps its body to a loader
// for at least 2 seconds, then renders the success/failure turbo stream returned by the server.
// Restores the original (large) promo modal when it is closed.
export default class extends Controller {
  static targets = ["body", "loader"]
  static values = { url: String }

  connect() {
    this.initialBody = this.bodyTarget.innerHTML
    this.dialog = this.element.closest(".modal-dialog")
    this.reset = this.reset.bind(this)
    this.modal = this.element.closest(".modal")
    if (this.modal) $(this.modal).on("hidden.bs.modal", this.reset)
  }

  disconnect() {
    if (this.modal) $(this.modal).off("hidden.bs.modal", this.reset)
  }

  async create() {
    this.dialog?.classList.remove("modal-lg")
    this.bodyTarget.innerHTML = this.loaderTarget.innerHTML

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const [response] = await Promise.all([
      fetch(`${this.urlValue}?from=modal`, {
        method: "POST",
        headers: { Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": token },
        credentials: "same-origin"
      }),
      new Promise((resolve) => setTimeout(resolve, 2000))
    ])

    Turbo.renderStreamMessage(await response.text())
  }

  reset() {
    this.dialog?.classList.add("modal-lg")
    this.bodyTarget.innerHTML = this.initialBody
  }
}
